import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

import { PARCEL_SERVICE_URL } from './constants'

export const parcelsApi = createApi({
  reducerPath: 'parcelsApi',
  baseQuery: fetchBaseQuery({ baseUrl: PARCEL_SERVICE_URL }),
  endpoints: (builder) => ({
    getParcelByPIN: builder.query<__esri.FeatureSet, string>({
      query: (pin) => `query?where=PIN+%3D+${pin}&outFields=*&returnGeometry=true&outSR=102100&f=json`,
    }),
    getParcelByTMS: builder.query<__esri.FeatureSet, string>({
      query: (tms) => `query?where=TMS+%3D+%27${tms}%27&outFields=*&returnGeometry=true&outSR=102100&f=json`,
    }),
  }),
})

export const { useGetParcelByPINQuery, useGetParcelByTMSQuery } = parcelsApi